export default __webpack_public_path__ + "static/media/rnr-sports-table-7.ee834671.webp";